import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Provide a sensible implementation
import * as React from "react";
import { Container, Row } from "./library/container";
import { LinkButton } from "./library/button";
export class Error extends React.Component {
    render() {
        return /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx(Row, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "error__wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: "Helaas"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "error__text",
                            children: "Deze pagina kan niet worden getoond."
                        }),
                        /*#__PURE__*/ _jsx(LinkButton, {
                            route: "/",
                            children: "Terug naar de homepage"
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props);
    }
}
export const AanZetErrorElement = /*#__PURE__*/ _jsx(Error, {});
